// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RebLJM {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.DNr5qL {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.VxR6i5 {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.N1k6Z9 {
  padding: var(--spacing-3) var(--spacing-1-5) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.fOq26Q {
  align-items: flex-start;
  padding-top: 30px;
}

.oKASUP {
  align-items: flex-start;
  padding-top: 45px;
}

.RjsFR3 {
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5);
}

.BvEvIn {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.dT39pi {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.dT39pi img {
  width: 16px;
  height: 16px;
}

.McH9uY {
  padding: var(--spacing-3);
  padding-top: 0;
  overflow-y: auto;
  min-height: 0;
  flex: 1;
}

.gFefGh {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
  color: #000;
  margin-bottom: var(--spacing-2);
  margin-left: 12px;
}

.LRrXCn {
  padding: var(--spacing-3);
  border-top: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-2);
  background: var(--surface-neutral-white);
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
}

.bIv7OI {
  background-color: var(--neutral-dark-opacity-50) !important;
}

.m8s1pJ {
  margin: 0;
  margin-bottom: var(--spacing-2);
  min-width: 0;
}

.Fnaak_ {
  margin-top: var(--spacing-2);
}

.ZhFyUn {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
  color: var(--text-neutral-strong);
}

.VxR6i5 .form-label {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-0-5);
}

.VxR6i5 .form-control,
.VxR6i5 .form-select {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  padding: var(--spacing-1-5);
  width: 100%;
}

.VxR6i5 .form-control[as='select'],
.VxR6i5 select.form-control {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  padding-right: 2.25rem;
  appearance: none;
}

.VxR6i5 .form-control:focus,
.VxR6i5 .form-select:focus {
  background-color: var(--surface-neutral-pale);
  border-color: var(--text-primary-medium);
  box-shadow: none;
}

.VxR6i5 .form-control::placeholder {
  color: var(--text-neutral-strong);
}

.VxR6i5 .form-control:disabled {
  background-color: var(--surface-neutral-pale);
  border-color: var(--surface-neutral-pale);
  color: var(--text-neutral-strong);
}

.VxR6i5 .form-check {
  display: flex;
  align-items: center;
  min-height: auto;
  margin: 0;
  padding-left: 0;
}

.VxR6i5 .form-check-label {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  padding-left: var(--spacing-1);
  margin-bottom: 0;
}

.VxR6i5 .form-check-input {
  float: none;
  margin-left: 0;
  border: 1px solid var(--stroke-neutral-stronger);
  border-radius: var(--radius-xs);
  width: 16px;
  height: 16px;
  margin-top: 0;
}

.VxR6i5 .form-check-input:checked {
  background-color: var(--text-primary-medium);
  border-color: var(--text-primary-medium);
}

.VxR6i5 .form-control.is-invalid,
.VxR6i5 .form-select.is-invalid {
  border-color: var(--status-error);
  padding-right: var(--spacing-1-5);
}

.VxR6i5 .form-control.is-invalid:not(select),
.VxR6i5 .form-select.is-invalid:not(select) {
  background-image: none;
}

.VxR6i5 .invalid-feedback {
  display: none;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger);
  margin-top: var(--spacing-0-5);
}

.VxR6i5 .was-validated .form-control:invalid ~ .invalid-feedback,
.VxR6i5 .was-validated .form-select:invalid ~ .invalid-feedback,
.VxR6i5 .form-control.is-invalid ~ .invalid-feedback,
.VxR6i5 .form-select.is-invalid ~ .invalid-feedback {
  display: flex;
}

.VxR6i5 .btn {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--radius-s);
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.VxR6i5 .btn-outline-primary {
  color: var(--text-primary-medium);
  border: 2px solid var(--text-primary-medium);
}

.VxR6i5 .btn-outline-primary:hover {
  color: var(--text-neutral-white);
  background-color: var(--text-primary-medium);
  border-color: var(--text-primary-medium);
}

.VxR6i5 .btn-primary {
  background-color: var(--text-primary-medium);
  border-color: var(--text-primary-medium);
  color: var(--text-neutral-white);
}

.VxR6i5 .btn-primary:hover {
  background-color: var(--text-primary-strong);
  border-color: var(--text-primary-strong);
}

.VxR6i5 .btn-primary:disabled,
.VxR6i5 .btn-outline-primary:disabled {
  background-color: var(--disabled-subtle-surface);
  border-color: var(--disabled-subtle-surface);
  color: var(--disabled-subtle-text);
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/AddressModal/AddressModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;;EAEE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,6CAA6C;EAC7C,8CAA8C;EAC9C,8BAA8B;EAC9B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;;EAEE,iPAAiP;EACjP,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,6CAA6C;EAC7C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gDAAgD;EAChD,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;EAEE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,4CAA4C;EAC5C,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;EAEE,gDAAgD;EAChD,4CAA4C;EAC5C,kCAAkC;EAClC,mBAAmB;AACrB","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-1-5) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.noNumberWrapper {\n  align-items: flex-start;\n  padding-top: 30px;\n}\n\n.dontKnowMyZipCodeWrapper {\n  align-items: flex-start;\n  padding-top: 45px;\n}\n\n.dontKnowMyZipCodeLink {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: 16px;\n  height: 16px;\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  padding-top: 0;\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n}\n\n.requiredFields {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n  color: #000;\n  margin-bottom: var(--spacing-2);\n  margin-left: 12px;\n}\n\n.modalFooter {\n  padding: var(--spacing-3);\n  border-top: none;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-2);\n  background: var(--surface-neutral-white);\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.backdrop {\n  background-color: var(--neutral-dark-opacity-50) !important;\n}\n\n.alert {\n  margin: 0;\n  margin-bottom: var(--spacing-2);\n  min-width: 0;\n}\n\n.complementInfo {\n  margin-top: var(--spacing-2);\n}\n\n.infoText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-strong);\n}\n\n.modalContent :global(.form-label) {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-0-5);\n}\n\n.modalContent :global(.form-control),\n.modalContent :global(.form-select) {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-1-5);\n  width: 100%;\n}\n\n.modalContent :global(.form-control[as='select']),\n.modalContent :global(select.form-control) {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 6 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  padding-right: 2.25rem;\n  appearance: none;\n}\n\n.modalContent :global(.form-control:focus),\n.modalContent :global(.form-select:focus) {\n  background-color: var(--surface-neutral-pale);\n  border-color: var(--text-primary-medium);\n  box-shadow: none;\n}\n\n.modalContent :global(.form-control::placeholder) {\n  color: var(--text-neutral-strong);\n}\n\n.modalContent :global(.form-control:disabled) {\n  background-color: var(--surface-neutral-pale);\n  border-color: var(--surface-neutral-pale);\n  color: var(--text-neutral-strong);\n}\n\n.modalContent :global(.form-check) {\n  display: flex;\n  align-items: center;\n  min-height: auto;\n  margin: 0;\n  padding-left: 0;\n}\n\n.modalContent :global(.form-check-label) {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  padding-left: var(--spacing-1);\n  margin-bottom: 0;\n}\n\n.modalContent :global(.form-check-input) {\n  float: none;\n  margin-left: 0;\n  border: 1px solid var(--stroke-neutral-stronger);\n  border-radius: var(--radius-xs);\n  width: 16px;\n  height: 16px;\n  margin-top: 0;\n}\n\n.modalContent :global(.form-check-input:checked) {\n  background-color: var(--text-primary-medium);\n  border-color: var(--text-primary-medium);\n}\n\n.modalContent :global(.form-control.is-invalid),\n.modalContent :global(.form-select.is-invalid) {\n  border-color: var(--status-error);\n  padding-right: var(--spacing-1-5);\n}\n\n.modalContent :global(.form-control.is-invalid:not(select)),\n.modalContent :global(.form-select.is-invalid:not(select)) {\n  background-image: none;\n}\n\n.modalContent :global(.invalid-feedback) {\n  display: none;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger);\n  margin-top: var(--spacing-0-5);\n}\n\n.modalContent :global(.was-validated .form-control:invalid ~ .invalid-feedback),\n.modalContent :global(.was-validated .form-select:invalid ~ .invalid-feedback),\n.modalContent :global(.form-control.is-invalid ~ .invalid-feedback),\n.modalContent :global(.form-select.is-invalid ~ .invalid-feedback) {\n  display: flex;\n}\n\n.modalContent :global(.btn) {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--radius-s);\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.modalContent :global(.btn-outline-primary) {\n  color: var(--text-primary-medium);\n  border: 2px solid var(--text-primary-medium);\n}\n\n.modalContent :global(.btn-outline-primary:hover) {\n  color: var(--text-neutral-white);\n  background-color: var(--text-primary-medium);\n  border-color: var(--text-primary-medium);\n}\n\n.modalContent :global(.btn-primary) {\n  background-color: var(--text-primary-medium);\n  border-color: var(--text-primary-medium);\n  color: var(--text-neutral-white);\n}\n\n.modalContent :global(.btn-primary:hover) {\n  background-color: var(--text-primary-strong);\n  border-color: var(--text-primary-strong);\n}\n\n.modalContent :global(.btn-primary:disabled),\n.modalContent :global(.btn-outline-primary:disabled) {\n  background-color: var(--disabled-subtle-surface);\n  border-color: var(--disabled-subtle-surface);\n  color: var(--disabled-subtle-text);\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `RebLJM`,
	"modalDialog": `DNr5qL`,
	"modalContent": `VxR6i5`,
	"modalHeader": `N1k6Z9`,
	"noNumberWrapper": `fOq26Q`,
	"dontKnowMyZipCodeWrapper": `oKASUP`,
	"dontKnowMyZipCodeLink": `RjsFR3`,
	"modalTitle": `BvEvIn`,
	"backButton": `dT39pi`,
	"modalBody": `McH9uY`,
	"requiredFields": `gFefGh`,
	"modalFooter": `LRrXCn`,
	"backdrop": `bIv7OI`,
	"alert": `m8s1pJ`,
	"complementInfo": `Fnaak_`,
	"infoText": `ZhFyUn`
};
module.exports = ___CSS_LOADER_EXPORT___;
